import styled from 'styled-components'
import { Field } from 'formik'

export const InputWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 2rem;

  .upload {
    width: 100%;
    border: dashed 2px ${({ theme }) => theme.text1};
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    min-height: 140px;
    padding: 1rem 0;

    &.error {
      border: dashed 2px ${({ theme }) => theme.red2};
    }

    .upload-preview {
      position: relative;
      width: 100%;
      height: 100%;

      .remove-upload {
        position: absolute;
        border: solid 1px ${({ theme }) => theme.text1};
        right: 20px;
        min-width: 40px;
        padding: 0.5rem;
        cursor: pointer;
      }
    }

    .upload-item-wrapper {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .upload-button {
        width: fit-content;
        background: ${({ theme }) => theme.bg6};
        color: #fff;
        padding: 0.5rem;
        margin-top: 1rem;
        font-weight: bold;
        cursor: pointer;
        user-select: none;

        :hover {
          background: ${({ theme }) => theme.bg7};
        }

        &.disabled {
          background: ${({ theme }) => theme.bg1};
          cursor: not-allowed;
          :hover {
            background: ${({ theme }) => theme.bg1};
          }
        }
      }
    }
  }
`

export const InputLabel = styled.label`
  width: 100%;
  text-align: left;
  margin-bottom: 0.5rem;
  font-weight: bold;
`

export const InputUpload = styled(Field)`
  width: 100%;
  background-color: transparent;
  border: none;
  border-bottom: solid 2px ${({ theme }) => theme.text1};
  padding: 0.5rem 0;
  border-radius: 0;
  outline: none;
  color: ${({ theme }) => theme.text1};
  display: none;

  &:hover {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.text1};
  }

  &:focus {
    border: none;
    border-bottom: solid 2px ${({ theme }) => theme.text1};
  }

  &.error {
    border-bottom: solid 2px ${({ theme }) => theme.red2};
  }
`

export const InputError = styled.div`
  width: 100%;
  font-size: 0.9rem;
  margin-top: 0.5rem;
  color: ${({ theme }) => theme.red2};
`
